module.exports = __webpack_public_path__ + "static/media/export-card-splitted.35cf647b.png";